import React, { ReactElement } from 'react'

import Navbar from '@instabox/internal-web-ui/components/Navbar'
import { Link, NavLink } from 'react-router-dom'

const links = [
  {
    text: 'Baseline',
    href: '/baseline',
  },
  {
    text: 'Current Rollout',
    href: '/rollout',
  },
  {
    text: 'Manage Rollout',
    href: '/rollout/manage',
  },
  {
    text: 'Devices',
    href: '/devices',
  },
  {
    text: 'Packages',
    href: '/package',
  },
]

function TopNavbar(): ReactElement {
  return (
    <Navbar
      title="Lockers Update"
      links={links}
      linkWrapper={(c) => <Link to="/">{c}</Link>}
      navLinkWrapper={({ text, href, className }) => (
        <NavLink to={href} className={className} exact>
          {text}
        </NavLink>
      )}
    />
  )
}

export default TopNavbar
